__turbopack_context__.v({
  "fadeIn": "FadeIn-module-scss-module__UZp2QW__fadeIn",
  "sentinel": "FadeIn-module-scss-module__UZp2QW__sentinel",
});
